export default __webpack_public_path__ + "static/media/testimonial-neet.1c23515e.png";